import { useMutation, useQueryClient } from '@tanstack/react-query';

import type {
  AnnotatedApiMutationMethodFactory} from '@shared/utils/makeApiQuery';
import {
  API_MUTATION_ANNOTATIONS,
  API_QUERY_ANNOTATIONS,
} from '@shared/utils/makeApiQuery';

export const useApiMutation = <TParams extends any[], TVariables = void, TResult = void>(
  method: AnnotatedApiMutationMethodFactory<TParams, TVariables, TResult>,
  ...params: TParams
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: method(...params),
    onSettled: async () => {
      if (method[API_MUTATION_ANNOTATIONS]) {
        if (method[API_MUTATION_ANNOTATIONS].affectedQueries) {
          const promises = method[API_MUTATION_ANNOTATIONS].affectedQueries.map(async (query) => {
            if (query[API_QUERY_ANNOTATIONS]) {
              const { queryKey } =
                typeof query[API_QUERY_ANNOTATIONS] === 'function'
                  ? query[API_QUERY_ANNOTATIONS](...params)
                  : query[API_QUERY_ANNOTATIONS];

              if (queryKey) {
                await queryClient.invalidateQueries({
                  queryKey,
                });
              }
            }
          });

          await Promise.all(promises);
        }
      }
    },
  });
};
